export { default, DPLLogoSmallOnPhone } from './DPLLogo';



// WEBPACK FOOTER //
// ./src/components/DPLLogo/index.js